module.exports = __webpack_public_path__ + "static/media/fly0139.dc506666.webp";